import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import { CompanyDirectorship } from '../models';
import { ReportCompanyPrintComponent } from '../../shared/components/report-company-print/report-company-print.component';
import { ReportDirectorPrintComponent } from '../../shared/components/report-director-print/report-director-print.component';
import { AuthService, UserSubscription } from '../../modules/auth';
import { DirectorshipProfileModalComponent } from '../../shared/components/directorship-profile-modal/directorship-profile-modal.component';
import { LayoutService } from '../../modules/layout';
@Injectable({
  providedIn: 'root',
})
export class ModalService {
  constructor(
    private readonly modalService: NgbModal,
    private authService: AuthService,
    private layout: LayoutService
  ) {}

  openDirectorProfile(directorship: CompanyDirectorship): NgbModalRef {
    const modalOptions: NgbModalOptions = {
      // backdrop: 'static',
      size: 'xl',
      scrollable: true,
      backdropClass: 'customBackdrop',
    };
    const modalRef = this.modalService.open(
      DirectorshipProfileModalComponent,
      modalOptions
    );

    // Pass the data
    modalRef.componentInstance.directorship = directorship;
    return modalRef;
  }

  //TODO: CHECK USER HAS PRO PLAN ACTIVE
  openCompanyPrintReport(
    title: string,
    data: any,
    subscription: UserSubscription | null
  ): NgbModalRef | undefined {
    if (!this.authService.hasActivePlan(['pro', 'enterprise'])) {
      this.layout.showPaywall('Unlock Premium to Access Printing Features');
      return;
    }
    const modalOptions: NgbModalOptions = {
      // backdrop: 'static',
      size: 'xl',
      scrollable: true,
      backdropClass: 'customBackdrop',
      windowClass: 'report-company-print-modal',
    };
    const modalRef = this.modalService.open(
      ReportCompanyPrintComponent,
      modalOptions
    );

    // Pass the data
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.data = data;
    modalRef.componentInstance.subscription = subscription;
    return modalRef;
  }

  //TODO: CHECK USER HAS PRO PLAN ACTIVE
  openDirectorPrintReport(
    title: string,
    ids: number[]
  ): NgbModalRef | undefined {
    if (!this.authService.hasActivePlan(['pro', 'enterprise'])) {
      this.layout.showPaywall('Unlock Premium to Access Printing Features');
      return;
    }
    const modalOptions: NgbModalOptions = {
      // backdrop: 'static',
      size: 'xl',
      scrollable: true,
      backdropClass: 'customBackdrop',
      windowClass: 'report-director-print-modal',
    };
    const modalRef = this.modalService.open(
      ReportDirectorPrintComponent,
      modalOptions
    );

    // Pass the data
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.ids = ids;
    return modalRef;
  }
  closeAll(): void {
    this.modalService.dismissAll();
  }
}
